export default path => () => import(`../../views/committee${path}.vue`);



// WEBPACK FOOTER //
// ./src/router/committee/view.js